import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD5w21ht3IqlVtDSutEMTyuCduyybiyNkQ',
  authDomain: 'cura-a5c8a.firebaseapp.com',
  projectId: 'cura-a5c8a',
  storageBucket: 'cura-a5c8a.firebasestorage.app',
  messagingSenderId: '364294221152',
  appId: '1:364294221152:web:f8993b1a49d1ed6faf4205',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
